import { loader } from './modules/_loader';
import { scrollAnimationHeader } from './modules/_scrollAnimationHeader';
import { scrollAnimationContents } from './modules/_scrollAnimationContents';
import { scrollAnimationContentsShow } from './modules/_scrollAnimationContents';
import { drawerMenu } from './modules/_drawerMenu';
import { modalWindow } from './modules/_modalWindow';
import { accordion } from './modules/_accordion';
import { postNavArea } from './modules/_postNavArea';
import { upButton } from './modules/_upButton';
import { smoothScroll } from './modules/_smoothScroll';
import { smoothScrollOutside } from './modules/_smoothScroll';
import { classAdd } from './modules/_classAdd';

document.addEventListener('DOMContentLoaded', () => {
  loader();
  scrollAnimationHeader();
  scrollAnimationContents();
  drawerMenu();
  postNavArea();
  upButton();
  classAdd();
});

window.addEventListener('load', () => {
  scrollAnimationContentsShow();
  modalWindow();
  accordion();
});

window.addEventListener('onload', () => {
  smoothScroll();
  smoothScrollOutside();
});
